import React, { useEffect } from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { RouteComponentProps, useLocation, useParams } from '@reach/router';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: '100px',
  },
  codeContainer: {
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.3)',
  },
}));

function Error() {
  const classes = useStyles();
  const params = useParams();

  return (
    <Grid container justifyContent="center" className={classes.root}>
      <Grid item xs={12}>
        <Typography className={classes.codeContainer} variant="h1">
          ERROR {params.errorCode}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default Error;
